import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { Store, StoreResponse } from '../interfaces/store.interface';
import {AuthService} from "./auth.service";

export const getStoresByInstitutionId = async (page: number = 0, size: number = 10): Promise<StoreResponse> => {
    const institutionId = AuthService.getSelectedInstitution();
    const response = await axios.get(`${ENDPOINTS.STORE.LIST_BY_INSTITUTION}/${institutionId}?page=${page}&size=${size}`);
    return response.data;
};

export const getAllInstitutionStores = async (page: number = 0, size: number = 10): Promise<StoreResponse> => {
    const response = await axios.get(`${ENDPOINTS.STORE.BASE}?page=${page}&size=${size}`);
    return response.data;
};

export const createStore = async (store: Store): Promise<void> => {
    await axios.post(ENDPOINTS.STORE.BASE, store);
};

export const updateStore = async (id: string, store: Store): Promise<void> => {
    await axios.put(`${ENDPOINTS.STORE.BASE}/${id}`, store);
};

export const deleteStore = async (id: string): Promise<void> => {
    await axios.delete(ENDPOINTS.STORE.DELETE(id));
};
